import { Component, OnInit } from '@angular/core';
import { BusyProvider } from '../service/busy.service';

declare var $: any;

@Component({
  selector: 'app-busy',
  templateUrl: './busy.component.html',
  styleUrls: ['./busy.component.css']
})

export class BusyComponent implements OnInit {
       
  constructor(private busyProvider: BusyProvider) {
      this.busyProvider.getBusyIndicator().subscribe((busy) => { 
          if(busy == "show") {
              $("#srmBusyLoader").show();
              $("#srmBlockDiv").show();
          }  else if(busy == "hide") {
              $("#srmBusyLoader").hide();
              $("#srmBlockDiv").hide();
          }
      });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/busy/busy.component.ts